<template>
  <div class="docs-operation">
    <!-- 分享 -->
    <a-tooltip :getPopupContainer="triggerNode => triggerNode.parentNode" v-if="hasSharePermission">
      <template slot="title">{{ $t('com_btn_share') }}</template>
      <a-button
        type="primary"
        @click="
          () => {
            $refs.share.show(true, record);
          }
        "
        class="g-btn-icon"
      >
        <Icon type="share" />
      </a-button>
    </a-tooltip>

    <Share ref="share" v-if="hasSharePermission" />

    <!-- 编辑 -->
    <!-- 编辑数据权限：user wikiReadLevel<= record  writeLevel-->
    <!-- level值越小，权限越大 -->
    <a-tooltip
      :getPopupContainer="triggerNode => triggerNode.parentNode"
      v-if="hasEditContentPermission"
    >
      <template slot="title">{{ $t('com_btn_edit_content') }}</template>
      <router-link
        :to="{
          name: 'DocsContentUpdate',
          params: { id: record.id, categoryId: record.wikiCategoryId },
        }"
        class="g-btn-link-icon"
      >
        <a-button type="primary">
          <Icon type="edit" />
        </a-button>
      </router-link>
    </a-tooltip>

    <!-- 编辑属性 -->
    <!-- 编辑数据权限：user wikiReadLevel<= record  writeLevel-->
    <!-- level值越小，权限越大 -->
    <a-tooltip
      :getPopupContainer="triggerNode => triggerNode.parentNode"
      v-if="!toggle.edit && hasEditPropPermission"
    >
      <template slot="title">{{ $t('com_btn_edit_prop') }}</template>
      <router-link
        :to="{
          name: 'DocsPropsUpdate',
          params: { id: record.id },
        }"
        class="g-btn-link-icon"
      >
        <a-button type="primary">
          <Icon type="edit" />
        </a-button>
      </router-link>
    </a-tooltip>

    <!-- 删除 -->
    <a-tooltip
      :getPopupContainer="triggerNode => triggerNode.parentNode"
      v-if="hasDeletePermission"
    >
      <template slot="title">{{ $t('com_btn_delete') }}</template>
      <a-button
        type="red"
        @click="
          deleteDocument({
            params: { id: record.id },
            name: record.title,
            callback: deleteCallback,
          })
        "
        class="g-btn-icon"
      >
        <Icon type="delete" />
      </a-button>
    </a-tooltip>

    <a-popover
      trigger="hover"
      placement="bottom"
      overlayClassName="custom-popover-menu custom-popover-noarrow"
      v-if="popover && (hasEnablePermission || hasDisablePermission || hasEditPropPermission)"
    >
      <template slot="content" v-if="record">
        <ul class="g-ellipsis-menu">
          <!-- 已禁用 -->
          <li
            @click="
              enableDocument({
                params: { id: record.id, enable: true },
                name: record.title,
              })
            "
            v-if="hasEnablePermission"
          >
            <ins><a-icon type="play-circle"/></ins>
            <span>{{ $t('com_btn_enabled2') }}</span>
          </li>

          <!-- 已启用 -->
          <li
            @click="
              disabledDocument({
                params: { id: record.id, enable: false },
                name: record.title,
              })
            "
            v-if="hasDisablePermission"
          >
            <ins><Icon type="forbidden2"/></ins>
            <span>{{ $t('com_btn_disabled2') }}</span>
          </li>

          <!-- 编辑属性 -->
          <li
            @click="
              () => {
                this.$router.push({
                  name: 'DocsPropsUpdate',
                  params: { id: record.id },
                });
              }
            "
            v-if="hasEditPropPermission"
          >
            <ins><Icon type="edit"/></ins>
            <span>{{ $t('docs_form_edit_prop_title') }}</span>
          </li>
        </ul>
      </template>
      <a-button type="primary" class="ant-btn-ellipsis">
        <Icon type="ellipsis" />
      </a-button>
    </a-popover>

    <!-- 已禁用，操作启用，显示启用图标 -->
    <a-tooltip
      :getPopupContainer="triggerNode => triggerNode.parentNode"
      v-if="!popover && hasEnablePermission"
    >
      <template slot="title">{{ $t('com_btn_enabled') }}</template>
      <a-button
        type="primary"
        @click="
          enableDocument({
            params: { id: record.id, enable: true },
            name: record.title,
          })
        "
        class="g-btn-icon"
      >
        <Icon type="play-circle" />
      </a-button>
    </a-tooltip>

    <!-- 已启用，操作禁用，显示禁用图标 -->
    <a-tooltip
      :getPopupContainer="triggerNode => triggerNode.parentNode"
      v-if="!popover && hasDisablePermission"
    >
      <template slot="title">{{ $t('com_btn_disabled') }}</template>
      <a-button
        type="red"
        @click="
          disabledDocument({
            params: { id: record.id, enable: false },
            name: record.title,
          })
        "
        class="g-btn-icon"
      >
        <Icon type="forbidden2" />
      </a-button>
    </a-tooltip>

    <a-button
      type="default"
      @click="
        () => {
          if (typeof toggle.back === 'function') {
            toggle.back();
          } else {
            this.$router.go(-1);
          }
        }
      "
      v-if="toggle.back"
    >
      {{ $t('docs_return_list') }}
    </a-button>
  </div>
</template>
<script>
import { copyContent } from '@/libs/utils';
import Share from '@/views/docs/components/Share';
import { mapState } from 'vuex';
import { hasReadWritePermission } from '@/libs/permissions';
import docsAuth from '@/views/docs/mixins/docsAuth';

import docsOperations from '@/views/docs/mixins/operations';
export default {
  components: {
    Share,
  },
  mixins: [docsAuth, docsOperations],
  props: {
    record: Object,
    popover: {
      type: Boolean,
      default: true,
    },
    toggle: {
      type: Object,
      default: () => {
        return {
          back: false,
          edit: false,
          delete: false,
          enable: false,
          disable: false,
          props: false,
          share: false,
        };
      },
    },
    isList: {
      type: Boolean,
      default: false,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['userInfo', 'authList']),

    // 是否有数据编辑（包括删除、禁用等）权限
    hasWritePermissioin() {
      const _writeLevel = hasReadWritePermission('write', 'wiki', this.record.writeLevel);
      return _writeLevel;
    },

    // 有分享的权限
    hasSharePermission() {
      return this.record && this.toggle.share;
    },

    // 有编辑内容的权限
    hasEditContentPermission() {
      return (
        this.record && this.toggle.edit && this.hasWritePermissioin && this.AUTH_DOCS_CONTENT_EDIT
      );
    },

    // 有删除的权限
    hasDeletePermission() {
      return this.record && this.toggle.delete && this.hasWritePermissioin && this.AUTH_DOCS_DELETE;
    },

    // 有启用的权限
    hasEnablePermission() {
      return (
        this.record &&
        this.record.enable === false &&
        this.toggle.enable &&
        this.hasWritePermissioin &&
        this.AUTH_DOCS_ENABLE_DISABLE
      );
    },

    // 有禁用的权限
    hasDisablePermission() {
      return (
        this.record &&
        this.record.enable === true &&
        this.toggle.disable &&
        this.hasWritePermissioin &&
        this.AUTH_DOCS_ENABLE_DISABLE
      );
    },

    // 有编辑属性的权限
    hasEditPropPermission() {
      return this.record && this.toggle.props && this.hasWritePermissioin && this.AUTH_DOCS_EDIT;
    },
  },
  data() {
    return {
      copyContent,
      shareVisible: false,
    };
  },
  methods: {
    deleteCallback() {
      if (this.isDetail) {
        this.$router.go(-1);
      } else if (this.isList) {
        this.$emit('callback');
      }
    },
  },
};
</script>
<style lang="less" scoped>
.docs-operation {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
</style>
